<template>
    <div class="normal-container py-5">
        <h1 class="text-center">
            Keep Your Account Active By Observing The Acceptable Use Visitation
            Policy.
        </h1>
        <h2 class="text-secondary text-center mt-3">
            If you have any questions,<br />please contact Customer Support via
            Live Chat
        </h2>

        <div class="row mt-5">
            <div class="col-lg-10 mx-auto">
                <p class="mb-5 text-center">
                    iWebVisit expects all visitors to dress and behave as if
                    they were visiting a jail in person. Many of the jails we
                    service have specific rules posted on their websites and we
                    encourage visitors to review them. All visitors must abide
                    by iWebVisit policies and the rules of the facility they
                    visit. Failure to comply with stated policies will result in
                    your visit being terminated and your account being blocked.
                    Visits that are terminated for policy violations will not be
                    credited.
                </p>

                <h2 class="text-primary text-center my-4 my-md-5">
                    Usage Policies for Standard Remote Visitation
                </h2>

                <ol>
                    <li>
                        The account must be set up in the legal name of the
                        primary visitor. This person is responsible for the
                        payment of the visit and the behavior of everyone in the
                        visit.
                    </li>
                    <li>
                        If you are sent a warning during your visit, obey it.
                        Arguing/complaining will not change the policy.
                    </li>
                    <li>
                        Everyone participating in the visit must be in view of
                        the camera.
                    </li>
                    <li>
                        Unauthorized communication between inmates is not
                        allowed.
                    </li>
                    <li>Do not use or display drugs or drug paraphernalia.</li>
                    <li>
                        Do not display guns, violent imagery, or gang-related
                        clothing/symbols.
                    </li>
                    <li>Do not operate a motor vehicle while visiting.</li>
                    <li>Do not display pornographic images.</li>
                    <li>
                        Do not visit without a parent or guardian if you are
                        younger than 18 years old.
                    </li>
                    <li>Do not allow blocked visitors to use your account.</li>
                    <li>
                        Do not stream, record, or take pictures of your visit.
                    </li>
                    <li>Do not conduct third-party calls while visiting.</li>
                    <li>
                        The inmate you choose when scheduling is the only one
                        who may attend your visit.
                    </li>
                    <li>
                        Do not allow children to be in the view of the camera
                        unless they are completely dressed.
                    </li>
                    <li>
                        Your visits are NEVER private. Do not dress
                        inappropriately and do not be sexually explicit.
                    </li>
                </ol>

                <div class="my-5 text-center">
                    Examples of inappropriate clothing for both male and female
                    visitors: swimsuits, exposed underwear, skin-tight garments
                    (leotards, bodysuits, etc.), halter tops, tube tops, or
                    thin-strapped shirts, see-through clothing, and any attire
                    that reveals excessive skin on the torso and/or legs such as
                    low-cut tops and shorts/skirts cut higher than 3" above the
                    knee.
                </div>
            </div>
        </div>

        <testimonial></testimonial>
    </div>
</template>

<script>
import Testimonial from '@/components/Testimonial.vue';
export default {
    components: { Testimonial },
};
</script>

<style scoped>
ol > li {
    padding-top: 1.1rem;
    padding-bottom: 1.1rem;
}

@media screen and (max-width: 575px) {
    ol > li {
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
    }
}
</style>
